/**
 * Contact Information Constants
 * Centralized contact details for the application
 */

export const CONTACT_INFO = {
  email: 'packmycart.help@gmail.com',
  phone: '+1 (876) 555-CART',
  address: 'Discovery Bay, Jamaica',
  supportEmail: 'packmycart.help@gmail.com',
  businessEmail: 'packmycart.help@gmail.com',

  // Social Media (add as needed)
  // facebook: 'https://facebook.com/packmycart',
  // twitter: 'https://twitter.com/packmycart',
  // instagram: 'https://instagram.com/packmycart',

  // Business Hours
  businessHours: {
    weekdays: '9:00 AM - 6:00 PM',
    weekends: '10:00 AM - 4:00 PM',
    timezone: 'EST',
  },
};

export default CONTACT_INFO;
